import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

export default function useToken() {
  const { getAccessTokenSilently } = useAuth0()
  const [state, setState] = useState({
    error: null,
    loading: true,
    headers: null,
  })

  useEffect(() => {
    async function fetchAccessToken() {
      try {
        const accessToken = await getAccessTokenSilently()
        setState((prevState) => ({
          ...prevState,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          error: null,
          loading: false,
        }))
      } catch (error) {
        setState((prevState) => ({
          ...prevState,
          error,
          loading: false,
        }))
      }
    }

    fetchAccessToken()
  }, [getAccessTokenSilently])
  return { ...state }
}
